import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{attrs:{"height":"auto"}},[_c(VLayout,{attrs:{"justify-center":""}},[_c(VFlex,{attrs:{"text-xs-center":""}},[_c(VCard,{staticClass:"white--text text-center",attrs:{"flat":"","title":"","color":"grey darken-2"}},[_c(VCardText,{staticClass:"white--text pt-2"},[_c('h3',[_vm._v("Easy Rent © "+_vm._s(new Date().getFullYear())+" Powered by Tedesco Dev")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }